// extracted by mini-css-extract-plugin
export default {"content":"styles_content__-1ExU","footer":"styles_footer__QtHKe"};